export default {
      id: "car-r-side-usage",
      viewBox: "0 0 112 33",
      url: __webpack_public_path__ + "img/icons.svg#car-r-side",
      toString: function () {
        return this.url;
      }
    }